<template>
  <div class="card"
       v-tooltip="!hidden ? card.name : null"
       :class="{ sm: size == 'sm', md: size == 'md', 'can-be-removed': canBeRemoved, 'can-be-played': canBePlayed, 'can-be-discarded': canBeDiscarded, 'can-be-held-back': canBeHeldBack, 'can-be-chosen': canBeChosen }">
    <template v-if="hidden">
      <img src="../../public/assets/images/card-back.jpg" alt="">
    </template>
    <template v-else="">
      <img :src="`assets/images/${card.imageName}.jpg`" alt="">
      <div class="card-text">
        <span class="name">{{ card.name }}</span>
        <span class="name">{{ card.name }}</span>
      </div>
    </template>
    <div class="buttons">
      <button class="btn discard"
              @click="discard">Discard
      </button>
      <button class="btn hold-back"
              @click="holdBack">Hold Back
      </button>
      <button class="btn choose"
              @click="choose">Choose
      </button>
      <button class="btn play"
              @click="play">Play
      </button>
      <button class="btn remove"
              @click="remove">Remove
      </button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'Card',
  props: {
    card: {
      type: Object,
    },
    size: {
      type: String,
      default: 'md',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    canBePlayed: {
      type: Boolean,
      default: false,
    },
    canBeDiscarded: {
      type: Boolean,
      default: false,
    },
    canBeHeldBack: {
      type: Boolean,
      default: false,
    },
    canBeChosen: {
      type: Boolean,
      default: false,
    },
    canBeRemoved: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    play() {
      if (!this.canBePlayed) {
        return;
      }
      this.card.playedAt = DateTime.utc().toISO();
      this.$emit('played');
    },
    discard() {
      if (!this.canBeDiscarded) {
        return;
      }
      this.$emit('discarded');
    },
    holdBack() {
      if (!this.canBeHeldBack) {
        return;
      }
      this.$emit('held-back');
    },
    choose() {
      if(!this.canBeChosen) {
        return;
      }
      this.$emit('chosen');
    },
    remove() {
      if(!this.canBeRemoved || this.card.noHoldBack) {
        return;
      }
      this.$emit('remove');
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: solid 1px #aaa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.2cm 0.25cm #00000033;
  border-radius: 0.2cm;
  position: relative;
  background: #ffffff;
  color: #333;
  cursor: pointer;
  flex-shrink: 0;

  .card-text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .name {
      position: absolute;
      z-index: 1;
      text-align: center;
      left: 0;
      right: 0;
      text-transform: uppercase;
      color: #000;
      font-weight: 600;
      text-shadow: 0 0.1rem 0.4rem #fff;
      font-size: 0.9vw;
    }

    .name:first-of-type {
      top: 0.96vw;
    }

    .name:last-of-type {
      bottom: 0.66vw;
    }
  }

  .buttons {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90%;

    button {
      width: 100%;
      margin-bottom: 0.4vw;
    }
  }

  button {
    display: none;
  }

  &:hover {
    &.can-be-played {
      button.play {
        display: block;
      }
    }

    &.can-be-discarded {
      button.discard {
        display: block;
      }
    }

    &.can-be-held-back {
      button.hold-back {
        display: block;
      }
    }

    &.can-be-chosen {
      button.choose {
        display: block;
      }
    }

    &.can-be-removed {
      button.remove {
        display: block;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
  }

  span {
    margin: 1.8vw;
    text-align: center;
    font-weight: bold;
    font-size: 1.2vw;
  }

  .suite-value {
    position: absolute;
    top: 0.6vw;
    left: 0.8vw;
    font-size: 1.3vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    &.reversed {
      top: initial;
      left: initial;
      bottom: 0.6vw;
      right: 0.8vw;
      transform: rotate(180deg);
    }

    &.red {
      color: red;
    }

    .value {
      font-weight: bold;
    }

    .suite {
      margin-top: -0.7vw;
      font-size: 1.7vw;
    }
  }

  &.md {
    width: 15vw;
    height: 21vw;
  }

  &.sm {
    width: 2.5vw;
    height: 3.5vw;
    box-shadow: 0 0.2cm 0.25cm #00000033;
    border-radius: 0.4vw;
    margin-bottom: 0.5vw;

    span {
      display: none;
    }

    .suite-value {
      font-size: 0.85em;

      &.reversed {
        display: none;
      }

      .suite {
        margin-top: -0.35vw;
        font-size: 1.4vw;
      }
    }
  }
}
</style>
